import { Box, Typography, Avatar } from "@mui/material";

const SubMenuTooltip = ({ subMenu = [], onSubMenuClick = () => {} }) => {
  console.log("submenu at SubMenuTooltip ", subMenu);
  return (
    <>
      {/* <Box className="crew-menu">
      {subMenu.map((item, i) => (
        <Box
          key={i}
          className="crew-menu-item"
          onClick={() => onSubMenuClick(item)}
        >
          <div className="w-[50px] h-[50px] flex items-center justify-center me-2">
            {item.icon ? (
              <Avatar
                src={item.icon}
                variant="square"
                sx={{ width: 24, height: 24 }}
              />
            ) : (
              <Box
                component="i"
                className="icon-img"
                sx={{ width: 24, height: 24 }}
              />
            )}
          </div>

          <p className="text-paratext text-size-16">{item.label}</p>
        </Box>
      ))}
    </Box> */}

      <div className="rounded-[14px] py-2 px-2 text-center bg-white shadow-shd-on absolute w-full bottom-[-148px] z-10">
        {subMenu.map((item, i) => (
          <div className="flex items-center gap-1 hover:bg-slate-100 transition-opacity rounded-md"  onClick={() => onSubMenuClick(item)} key={i}>
            <div className="">
              {item.icon ? (
                <Avatar
                  src={item.icon}
                  variant="square"
                  sx={{ width: '37px', height: '38px' }}
                />
              ) : (
                <Box
                  component="i"
                  className="icon-img"
                  sx={{ width: '37px', height: '38px' }}
                />
              )}
            </div>
            <p className="text-paratext text-size-14">{item.label}</p>
          </div>
        ))}
      </div>
    </>
  );
};

export default SubMenuTooltip;
